import Crud from '../views/Cidade/Crud'
import Entity from '../views/Cidade/Add'

let routes = {
    path: '/cidades',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/cidades/add',
            name: 'NewCidade',
            component: Entity
        },
        {
            path: '/cidades/edit/:id?',
            name: 'EditCidade',
            component: Entity
        },
        {
            path: '/cidades',
            name: 'list-cidades',
            component: Crud,
            meta: {
                pageTitle: 'Lista de cidades',
                breadcrumb: [
                    {
                        text: 'Cidades',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
